import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StudentNavClassroomsResponse } from '@edtech-ui/core/models/nav-courses-and-quizzes/get-all-nav-student-classroom';
import { StudentRecentUpdatesResponse } from '@edtech-ui/core/models/student-recent-updates/student-recent-quiz';
import { MarkContentVisitedResponse, StudentMarkContentVisitedPayload } from '@edtech-ui/core/models/student-recent-updates/student-updated-marked';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentService {

	apiUrl= environment.studentApiUrl;

  constructor(private readonly http:HttpClient) { }

	getStudentsRecentUpdates(classroomId:number,pageNo:number = 1,pageLimit:number = 6):Observable<StudentRecentUpdatesResponse>{
		const params = new HttpParams().set('page',pageNo).set('page_size',pageLimit);
		return this.http.get<StudentRecentUpdatesResponse>(`${this.apiUrl}/unread-content/${classroomId}` , {params});
	}

	postStudentRecentMarkedVisited(payload:StudentMarkContentVisitedPayload):Observable<MarkContentVisitedResponse>{
		return this.http.post<MarkContentVisitedResponse>(`${this.apiUrl}/mark-content-visited`, payload);
	}

	getAllNavStudentClassrooms(pageNo: number = 1): Observable<StudentNavClassroomsResponse> {
		const params = new HttpParams().set('page', pageNo);
		return this.http.get<StudentNavClassroomsResponse>(`${this.apiUrl}/getAllStudentClassrooms`, { params });
	}

}